import React from 'react';
import MessageMethod from '../MessageMethod';
import MessagePreferences from '../MessagePreferences';

export default function Messaging() {
  return (
    <>
      <MessagePreferences />
      <MessageMethod />
    </>
  );
}